import React from 'react';
import './styles.css'

function Header() {
  return <header className='app-header'>
    <div className='app-header-content'></div>
  </header>;
}

export default Header;